export default "__VITE_ASSET__CTwGtALh__"